import { render, staticRenderFns } from "./transactionInventoryForm.vue?vue&type=template&id=37baeea3&"
import script from "./transactionInventoryForm.vue?vue&type=script&lang=js&"
export * from "./transactionInventoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports